export enum AuthOPEEnum {
  ResetPassword = "sendResetPasswordEmail",
  ChangeUserPassword = 'changeUserPassword',
  SaveNewPassword = "saveNewPassword",
  ImpersonateUser = "impersonateUser",
  RevokeUserSessions = "revokeUserSessions"
}
